var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-404"},[_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Main page")])],1),_c('h3',[_vm._v("Not found")])])}
var staticRenderFns = []

export { render, staticRenderFns }